var radii_px = {
  none: 0,
  "default": '2px',
  sm: '4px',
  md: '6px',
  lg: '8px',
  pill: '50rem'
};
var radii = radii_px;
var radii_rem = {
  none: 0,
  "default": '0.125rem',
  sm: '0.25rem',
  md: '0.375rem',
  lg: '0.5rem',
  pill: '50rem'
};
function getRadii () {
  var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'px';
  return unit === 'px' ? radii_px : radii_rem;
}

export default getRadii;
export { radii, radii_px, radii_rem };
//# sourceMappingURL=radii.esm.js.map
